var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('topBar'),_c('v-container',[_c('div',{staticClass:"mt-5 col-12 col-md-4 mx-auto"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }